var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"c-table__body"},_vm._l((_setup.props?.dado?.contasAReceber),function(contaAReceber){return _c(_setup.LinhaDeContasAReceber,{key:contaAReceber.id,attrs:{"dado":_setup.props?.dado,"contaAReceber":contaAReceber},on:{"update:alteraContaAReceber":_setup.alteraContaAReceber}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }